import { render, staticRenderFns } from "./ReminderPage.vue?vue&type=template&id=37299751&scoped=true&lang=pug"
import script from "./ReminderPage.vue?vue&type=script&lang=js"
export * from "./ReminderPage.vue?vue&type=script&lang=js"
import style0 from "./ReminderPage.vue?vue&type=style&index=0&id=37299751&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37299751",
  null
  
)

export default component.exports